import React from "react";
import { IoTicketOutline } from "react-icons/io5";

const BuyTicketsButton = () => {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="buy-tickets-button"
      href="https://www.kortosfera.uwm.edu.pl/kup-bilet/"
    >
      <IoTicketOutline size="24px" className="icon" />
      Kup bilety
    </a>
  );
};

export default BuyTicketsButton;
